var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightRail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 533,
    viewBox: "0 0 533 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.499 1.15269e-05C119.55 1.15269e-05 0 119.553 0 266.504C0 413.447 119.55 533 266.499 533C413.447 533 533 413.447 533 266.504C533 119.553 413.447 1.15269e-05 266.499 1.15269e-05Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.499 489C143.81 489 44 389.188 44 266.503C44 143.816 143.81 44 266.499 44C389.184 44 489 143.816 489 266.503C489 389.188 389.184 489 266.499 489",
    fill: "#EE263A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190 399V125.933C190 122.898 192.636 121 194.897 121H239.337C241.6 121 244.234 122.898 244.234 125.933V350.772H352.726C356.498 350.772 358 353.048 358 357.232V393.687C358 396.34 356.117 399 353.103 399H190",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRail);
export default __webpack_public_path__ + "static/media/LightRail.d3e28ded.svg";
export { ForwardRef as ReactComponent };